import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { config, encodeBase64RequestBody, nameFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const ContactEdit = () => {
  const { id_contact } = useParams();
  const [ companies, setCompanies ] = useState(null);
  const [ companyGroup, setCompanyGroup ] = useState(null);
  const [ contactName, setContactName ] = useState('');
  const [ contactEmail, setContactEmail ] = useState('');
  const [ contactPhone, setContactPhone ] = useState('');
  const [ contactPosition, setContactPosition ] = useState('');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    if (companies) {
      getContact();
    }
  }, [companies]);

  const getContact = async () => {
    try {
      const requestGetContact = {
        id_contact_person: id_contact
      };
      const fetchGetContact = await jwtFetch(config.ENDPOINT + 'get/contact_person', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestGetContact)
      });
      const responseGetContact = await fetchGetContact.json();
      if (responseGetContact.status === 200) {
        changeCompanyData(responseGetContact.data[0].company_id);
        setContactName(responseGetContact.data[0].cperson_name);
        setContactEmail(responseGetContact.data[0].cperson_email);
        setContactPhone(responseGetContact.data[0].cperson_phone);
        setContactPosition(responseGetContact.data[0].cperson_position);
      }
    } catch (error) {
      console.error('Error in getContact:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getCompanies = async () => {
    try {
      const requestGetCompanies = {
        "company_status": 'Active'
      };
      const fetchGetCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestGetCompanies)
      });
      const responseGetCompanies = await fetchGetCompanies.json();
      if (responseGetCompanies.status === 200) {
        for (let i in responseGetCompanies.data) {
          responseGetCompanies.data[i].value = responseGetCompanies.data[i].id_company;
          responseGetCompanies.data[i].label = responseGetCompanies.data[i].company_name;
        }
        setCompanies([...responseGetCompanies.data].sort((a, b) => (a.company_name || '').localeCompare(b.company_name || '')));
      } else {
        alert(responseGetCompanies.message);
      }
    } catch (error) {
      console.error('Error in getCompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const changeCompanyData = (value) => {
    const company = companies.find(company => company.id_company == value);
    setCompanyGroup(company);
  }

  const submitContactEdit = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);

      const requestContactEdit = {
        "id_contact_person": id_contact,
        "company_id": companyGroup.id_company,
        "cperson_name": contactName,
        "cperson_email": contactEmail,
        "cperson_phone": contactPhone,
        "cperson_position": contactPosition
      };
      const fetchContactEdit = await jwtFetch(config.ENDPOINT + 'update/contact_person', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestContactEdit)
      });
      const responseContactEdit = await fetchContactEdit.json();
      if (responseContactEdit.status === 200) {
        window.location.href = "/client/contact/detail/" + id_contact;
      } else {
        alert(responseContactEdit.message);
      }
    } catch (error) {
      console.error('Error in submitContactEdit:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div id="contact-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="client"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Contact Edit</div>
                  <form className="row" onSubmit={(e) => submitContactEdit(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Company Group <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <Select value={companyGroup} options={companies} placeholder="" onChange={(e) => changeCompanyData(e.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={contactName} onChange={(e) => setContactName(e.target.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Email <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Phone</label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Position</label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={contactPosition} onChange={(e) => setContactPosition(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/client/contact/detail/' + id_contact}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Update'}</button>
                      </div>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactEdit;


